import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth/auth.guard';
import { FeatureGuard } from './guards/feature/feature.guard';

export const routes: Routes = [
  //Authenticated routes
  // Root route - handles OAuth callbacks and authenticated access
  {
    path: '',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () =>
      import('./pages/subscriptions/subscriptions.component').then((m) => m.SubscriptionsComponent),
  },
  {
    path: 'detalhes-da-assinatura/:id',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () =>
      import('./pages/subscriptions-details/subscriptions-details.component').then(
        (m) => m.SubscriptionsDetailsComponent
      ),
  },
  {
    path: 'atividades',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () =>
      import('./pages/activities/activities.component').then((m) => m.ActivitiesComponent),
  },
  {
    path: 'conteudo',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () =>
      import('./pages/content/content.component').then((m) => m.ContentComponent),
  },
  {
    path: 'ajuda',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () => import('./pages/help/help.component').then((m) => m.HelpComponent),
  },
  // {
  //   path: 'gerenciar-cargos',
  //   canActivate: [AuthGuard, FeatureGuard],
  //   loadComponent: () =>
  //     import('./pages/manager-roles/manager-roles.component').then((m) => m.ManagerRolesComponent),
  // },
  {
    path: 'configuracoes',
    canActivate: [AuthGuard, FeatureGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
      },
      {
        path: 'editar-plano',
        loadComponent: () =>
          import('./pages/settings/pages/plan-register/plan-register.component').then(
            (m) => m.PlanRegisterComponent
          ),
      },
      {
        path: 'editar-cupom',
        loadComponent: () =>
          import('./pages/settings/pages/coupon-register/coupon-register.component').then(
            (m) => m.CouponRegisterComponent
          ),
      },
      {
        path: 'editar-permissao',
        loadComponent: () =>
          import('./pages/settings/pages/permission-register/permission-register.component').then(
            (m) => m.PermissionRegisterComponent
          ),
      },
      {
        path: 'tema',
        loadComponent: () =>
          import('./pages/settings/pages/theme/theme.component').then((m) => m.ThemeComponent),
      },
    ],
  },
  {
    path: 'conteudo',
    canActivate: [AuthGuard, FeatureGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/content/content.component').then((m) => m.ContentComponent),
      },
      {
        path: 'editar-faq-vitrine',
        loadComponent: () =>
          import('./pages/content/pages/faq-register/faq-register.component').then(
            (m) => m.FaqRegisterComponent
          ),
      },
      {
        path: 'editar-faq-minhaconta',
        loadComponent: () =>
          import('./pages/content/pages/faq-register/faq-register.component').then(
            (m) => m.FaqRegisterComponent
          ),
      },
      {
        path: 'editar-editor',
        loadComponent: () =>
          import('./pages/content/pages/journalists-register/journalists-register.component').then(
            (m) => m.JournalistsRegisterComponent
          ),
      },
      {
        path: 'editar-premio',
        loadComponent: () =>
          import('./pages/content/pages/awards-register/awards-register.component').then(
            (m) => m.AwardsRegisterComponent
          ),
      },
    ],
  },
  {
    path: 'campanhas',
    canActivate: [AuthGuard, FeatureGuard],
    children: [
      {
        path: 'relatorios',
        loadComponent: () =>
          import('./pages/campaigns/pages/campaign-reports/campaign-reports.component').then(
            (m) => m.CampaignReportsComponent
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/campaigns/campaigns.component').then((m) => m.CampaignsComponent),
      },
      {
        path: 'nova-campanha',
        loadComponent: () =>
          import(
            './pages/campaigns/pages/campaign-register/campaign-register.component'
          ).then((m) => m.CampaignRegisterComponent),
      },
    ],
  },
  // {
  //   path: 'relatorios',
  //   canActivate: [AuthGuard, FeatureGuard],
  //   loadComponent: () =>
  //     import('./pages/reports/reports.component').then((m) => m.ReportsComponent),
  //   children: [
  //     {
  //       path: '',
  //       loadComponent: () =>
  //         import(
  //           './pages/reports/components/new-customers-renewals/new-customers-renewals.component'
  //         ).then((m) => m.NewCustomersRenewalsComponent),
  //     },
  //   ],
  // },
  {
    path: 'transacoes-financeiras',
    canActivate: [AuthGuard, FeatureGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/transactions/transactions.component').then(
            (m) => m.TransactionsComponent
          ),
      },
      {
        path: 'detalhes-da-transacao',
        loadComponent: () =>
          import('./pages/transaction-details/transaction-details.component').then(
            (m) => m.TransactionDetailsComponent
          ),
      },
      {
        path: 'status-do-cartao',
        loadComponent: () =>
          import('./pages/card-token-status/card-token-status.component').then(
            (m) => m.CardTokenStatusComponent
          ),
      },
    ],
  },
  {
    path: 'usuarios',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () => import('./pages/users/users.component').then((m) => m.UsersComponent),
  },
  {
    path: 'usuarios/editar-usuario/:id',
    canActivate: [AuthGuard, FeatureGuard],
    loadComponent: () =>
      import('./pages/user-detail/user-detail.component').then((m) => m.UserDetailComponent),
  },
  //Unauthencicated routes
  // OAuth callback route - handles SVM OAuth redirect
  {
    path: 'acesso',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/subscriptions/subscriptions.component').then((m) => m.SubscriptionsComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/auth/signup/signup.component').then((m) => m.SignupComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'create-password',
    loadComponent: () =>
      import('./pages/auth/create-password/create-password.component').then(
        (m) => m.CreatePasswordComponent
      ),
  },
  {
    path: 'login-without-password',
    loadComponent: () =>
      import('./pages/auth/login-without-password/login-without-password.component').then(
        (m) => m.LoginWithoutPasswordComponent
      ),
  },
  {
    path: 'confirmation',
    loadComponent: () =>
      import('./pages/auth/confirmation/confirmation.component').then(
        (m) => m.ConfirmationComponent
      ),
  },
  // Wildcard route - redireciona URLs não encontradas para a home do usuário
  {
    path: '**',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
